import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import Signup from "./pages/Login/Signup";
import Dashboard from "./pages/Dashboard/AdminDashboard/Dashboard";
import { useSelector, useDispatch } from "react-redux";
import ResetPassword from "./pages/Login/ForgotPassword";
import AdminDashboard from "./pages/Dashboard/AdminDashboard/AdminDashboard";
import TenantManagement from "./pages/Dashboard/ResidentManagement/ResidentManagement";
import UnderConstruction from "./pages/Dashboard/AdminDashboard/UnderConstruction";
import PropertyManagement from "./pages/Dashboard/PropertyManagement/PropertyManagement";
import Facilities from "./pages/Dashboard/Facilities/Facilities";
import Services from "./pages/Dashboard/Suppliers/Services";
import Announcements from "./pages/Dashboard/Announcements/Announcements";
import UserDashboard from "./pages/User/UserDashboard/UserDashboard";
import Profile from "./pages/User/UserProfile/Profile";
import Contacts from "./pages/Dashboard/Contacts/Contacts";
import Settings from "./pages/Dashboard/Settings/Settings";
import MaintenanceRequest from "./pages/User/Concerns/MaintenanceRequest";
import GuestRegistration from "./pages/User/Guest/GuestRegistration";
import AddGuests from "./pages/User/Guest/AddGuests";
import GuestCardDetails from "./pages/User/Guest/GuestCardDetails";
import Bills from "./pages/User/Billing/Bills";
import Paynow from "./pages/User/Billing/Paynow";
import RequestSummary from "./pages/User/UserDashboard/RequestSummary";
import Tasks from "./pages/User/UserDashboard/Tasks";
import WorkPermitUser from "./pages/User/WorkPermit/WorkPermitUser";
import DuesUser from "./pages/User/Billing/DuesUser";
import FacilitiesUser from "./pages/User/Facilities/FacilitiesUser";
import SOS from "./pages/User/Contacts/SOS";
import LaundryUser from "./pages/User/Suppliers/LaundryUser";
import WaterServiceUser from "./pages/User/Suppliers/WaterServiceUser";
import CleaningServicesUser from "./pages/User/Suppliers/CleaningServicesUser";
import OtherServicesUser from "./pages/User/UserDashboard/OtherServicesUser";
import AdminUser from "./pages/User/AdminTab/AdminUser";
import NotificationsUser from "./pages/User/UserDashboard/NotificationsUser";
import GuestHistory from "./pages/User/Guest/GuestHistory";
import HoaDirectory from "./pages/User/Contacts/HoaDirectory";
import BillingDetails from "./pages/User/Billing/BillingDetails";
import PaymentConfirmed from "./pages/User/Billing/PaymentConfirmed";
import WorkPermitConfirmation from "./pages/User/WorkPermit/WorkPermitConfirmation";
import RequestDetails from "./pages/User/WorkPermit/RequestDetails";
import PickleBallReservation from "./pages/User/Facilities/PickleBallReservation";
import ReservationConfirmation from "./pages/User/Facilities/ReservationConfirmation";
import GroupChat from "./pages/User/Chat/GroupChat";
import NotificationDetails from "./pages/User/UserDashboard/NotificationDetails";
import Gatepass from "./pages/User/Gatepass/Gatepass";
import GatepassConfirmation from "./pages/User/Gatepass/GatepassConfirmation";
import MaintenanceRequestConfirmation from "./pages/User/Concerns/MaintenanceRequestConfirmation";
import Suppliers from "./pages/User/Suppliers/Suppliers";
import GroupChatHome from "./pages/User/Chat/GroupChatHome";
import ConcernsForm from "./pages/User/Concerns/ConcernsForm";
import ConcernConfirmationPage from "./pages/User/Concerns/ConcernConfirmationPage";
import ConcernDetails from "./pages/User/Concerns/ConcernDetails";
import Complaints from "./pages/User/Concerns/Complaints";
import Analytics from "./pages/Dashboard/Analytics/Analytics";
import WorkPermitDetails from "./pages/Dashboard/WorkPermits/WorkPermitDetails";
import TenantDetailsFullpage from "./pages/Dashboard/TenantManagement/TenantDetailsFullpage";
import SecurityNewPage from "./pages/Dashboard/Security/SecurityNewPage";
import Inventoryv2 from "./pages/Dashboard/Inventory/Inventoryv2";
import ProfileWeb from "./pages/Dashboard/AdminProfile/ProfileWeb";
import NotificationWeb from "./pages/Dashboard/Notifications/NotificationWeb";
import Basketball from "./pages/User/Facilities/ClubHouse";
import UserProfile from "./pages/User/UserProfile/UserProfile";
import InvitationPage from "./pages/User/UserProfile/InvitationPage";
import OtherRequestServices from "./pages/User/UserDashboard/OtherRequestServices";
import CarStickerPage from "./pages/User/CarSticker/CarStickerPage";
import Marketplace from "./pages/User/Marketplace/Marketplace";
import NewListingProperty from "./pages/User/Marketplace/NewListingProperty";
import FunctionRoomRequest from "./pages/User/Facilities/FunctionRoomRequest";
import AiDevTool from "./pages/Dashboard/DevTools/AiDevTool";
import ResidentDetailsFullpage from "./pages/Dashboard/ResidentManagement/ResidentDetailsFullpage";
import Todos from "./pages/Dashboard/Todos/Todos";
import Tickets from "./pages/Dashboard/Tickets/Tickets";
import MarketplaceAdmin from "./pages/Dashboard/Marketplace/MarketplaceAdmin";
import WorkWeekSchedule from "./pages/Dashboard/WorkWeek/WorkWeekSchedule";
import FacilityDetailPage from "./pages/Dashboard/Facilities/FacilityDetailPage";
import SecurityDashboard from "./pages/SecurityMobile/SecurityDashboard";
import Home from "./pages/SecurityMobile/SecurityHome";
import ScanQR from "./pages/SecurityMobile/ScanQR";
import UserChat from "./pages/SecurityMobile/UserChat";
import Guests from "./pages/SecurityMobile/Guests";
import PasswordSecurityUserPage from "./pages/User/UserProfile/PasswordSecurityUserPage";
import AppWrapper from "./components/AppWrapper";
import PaymentPosted from "./pages/User/Billing/PaymentPosted";
import Gatepassdetails from "./pages/User/Gatepass/Gatepassdetails";
import BookingRequestDetails from "./pages/User/Facilities/BookingRequestDetails";
import ConcernConfirmation from "./pages/User/Concerns/ConcernConfirmation";
import CarStickerApplicationDetails from "./pages/User/CarSticker/CarStickerApplicationDetails";
import NewProduct from "./pages/User/Marketplace/NewProduct";
import Newparkingspace from "./pages/User/Marketplace/Newparkingspace";
import AdminDashboardLayout from "./pages/AdminMobileMode/AdminDashboardLayout";
import AdminHomeMobile from "./pages/AdminMobileMode/AdminHomeMobile";
import AdminTicketsPage from "./pages/AdminMobileMode/AdminTicketsPage";
import AdminChatPage from "./pages/AdminMobileMode/AdminChatPage";
import AdminProfilePage from "./pages/AdminMobileMode/AdminProfilePage";
import Parcels from "./pages/SecurityMobile/Parcels";
import ParcelLogs from "./pages/SecurityMobile/ParcelLogs";
import GuestForm from "./pages/SecurityMobile/GuestForm";
import GatepassMobile from "./pages/SecurityMobile/GatepassMobile";
import WorkPermitsAdminMobile from "./pages/Dashboard/AdminDashboard/WorkPermitsAdminMobile";
import AdminResidentListMobile from "./pages/AdminMobileMode/AdminResidentListMobile";
import AdminMobileOverview from "./pages/AdminMobileMode/AdminMobileOverview";
import AdminMobileConcerns from "./pages/AdminMobileMode/AdminMobileConcerns";
import AddConcernMobileAdmin from "./pages/AdminMobileMode/AddConcernMobileAdmin";
import UserDashboardLayout from "./pages/User/UserDashboardLayout.jsx/UserDashboardLayout";
import BillsPayment from "./pages/User/UserDashboard/BillsPayment/BillsPayment";
import ParcelForUser from "./pages/User/Parcel/ParcelForUser";
import ParcelUserDetailspage from "./pages/User/Parcel/ParcelUserDetailspage";
import NotificationsSecurity from "./pages/SecurityMobile/NotificationsSecurity";
import UserSettings from "./pages/SecurityMobile/UserSettings";
import PropertyManagementSecurity from "./pages/SecurityMobile/PropertyManagementSecurity";
import WaterMeterReading from "./pages/SecurityMobile/WaterMeterReading";
import WaterLogs from "./pages/SecurityMobile/WaterLogs";
import { setupAuthListener } from "./utils/firebase/Firebase.utils";
import { loadUser } from "./store/userSlice";
import { useEffect } from "react";
import NotPermitted from "./pages/User/UserDashboard/NotPermitted";
import AdminMobileConcernDetails from "./pages/AdminMobileMode/AdminMobileConcernDetails";
import Finance from "./pages/Dashboard/Finance/Finance";
import ErrorNoticePage from "./pages/User/UserDashboard/ErrorNoticePage";
import ParcelNotice from "./pages/Public/ParcelNotice";
import ContractorDashboardLayout from "./pages/Contractor/ContractorDashboardLayout";
import ContractorDashboard from "./pages/Contractor/ContractorDashboard";
import SecurityProfile from "./pages/SecurityMobile/SecurityProfile";
import AddMoveIn from "./pages/Contractor/AddMoveIn";
import AddWorkPermit from "./pages/Contractor/AddWorkPermit";
import AddGatePass from "./pages/Contractor/AddGatePass";
import ContractorTickets from "./pages/Contractor/ContractorTickets";
import ContractorChat from "./pages/Contractor/ContractorChat";
import InventoryIssuances from "./pages/SecurityMobile/InventoryIssuances";
import SecurityGatePassDetails from "./pages/SecurityMobile/SecurityGatePassDetails";
import ServiceRequest from "./pages/User/ServiceRequest/ServiceRequest";
import Alerts from "./pages/SecurityMobile/Alerts";
import SecurityIncidents from "./pages/SecurityMobile/SecurityIncidents";
import SecurityReporting from "./pages/SecurityMobile/SecurityReporting";
import ClockInOut from "./pages/SecurityMobile/ClockInOut";
import AllAnnouncements from "./pages/User/Announcements/AllAnnouncements";
import EditProfile from "./pages/User/UserProfile/EditProfile";
import OrgChart from "./pages/Dashboard/Contacts/OrgChart";
import ServiceRequestsMobile from "./pages/SecurityMobile/ServiceRequestsMobile";
import ContractorGatePassPage from "./pages/SecurityMobile/ContractorGatePassPage";
import ContractorWorkPermit from "./pages/SecurityMobile/ContractorWorkPermit";
import InventoryMobile from "./pages/SecurityMobile/InventoryMobile";
import WaterMeterReadingTableView from "./pages/SecurityMobile/WaterMeterReadingTableView";

function App() {
  const currentUser = useSelector((state) => state.userObject);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const unsubscribe = setupAuthListener(dispatch, loadUser);

  //   // Clean up the listener on component unmount
  //   return () => unsubscribe();
  // }, [dispatch]);

  if (
    !currentUser ||
    !currentUser.email ||
    currentUser.email === "" ||
    currentUser.email === null ||
    currentUser.email === undefined
  ) {
    return (
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="login" element={<Login />} />
            <Route path="invite/:id" element={<InvitationPage />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/parcel-notice/:id" element={<ParcelNotice />} />
            <Route path="*" element={<Login />} />
          </Routes>
        </Router>
      </div>
    );
  }

  // UI for the user only
  if (currentUser?.roles?.includes("user")) {
    return (
      <div className="App">
        <div className="relative">
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<UserDashboardLayout />}>
                <Route path="parcel-notice/:id" element={<ParcelNotice />} />

                <Route path="service-request" element={<ServiceRequest />} />
                <Route path="announcements" element={<AllAnnouncements />} />
                <Route index element={<UserDashboard />} />

                <Route path="dashboard" element={<UserDashboard />} />
                <Route path="error" element={<ErrorNoticePage />} />
                <Route path="car-sticker" element={<CarStickerPage />} />
                <Route
                  path="car-sticker/:id"
                  element={<CarStickerApplicationDetails />}
                />
                <Route path="marketplace" element={<Marketplace />} />

                <Route
                  path="new-listing-property"
                  element={<NewListingProperty />}
                />
                <Route path="new-product-service" element={<NewProduct />} />
                <Route path="new-parking-space" element={<Newparkingspace />} />
                <Route path="bills" element={<Bills />} />
                <Route path="bills-payment" element={<BillsPayment />} />
                <Route path="parcels" element={<ParcelForUser />} />
                <Route
                  path="parcel/:parcelId"
                  element={<ParcelUserDetailspage />}
                />

                <Route
                  path="payment-confirmed/:id"
                  element={<PaymentConfirmed />}
                />
                <Route path="payment-posted/:id" element={<PaymentPosted />} />
                <Route
                  path="billing-details/:id"
                  element={<BillingDetails />}
                />
                <Route path="paynow" element={<Paynow />} />
                <Route path="requests" element={<RequestSummary />} />
                <Route
                  path="request-details/:id"
                  element={<RequestDetails />}
                />
                <Route path="tasks" element={<Tasks />} />
                <Route path="gate-pass" element={<Gatepass />} />
                <Route
                  path="gatepass-confirmation/:id"
                  element={<GatepassConfirmation />}
                />
                <Route
                  path="gatepass-details/:id"
                  element={<Gatepassdetails />}
                />
                <Route path="work-permits" element={<WorkPermitUser />} />
                <Route
                  path="work-permit-confirmation/:id"
                  element={<WorkPermitConfirmation />}
                />
                <Route path="dues" element={<DuesUser />} />
                <Route path="facility-usage" element={<FacilitiesUser />} />
                <Route
                  path="user/facilities/:id"
                  element={<FunctionRoomRequest />}
                />
                <Route path="booking/:id" element={<BookingRequestDetails />} />
                <Route path="basketball" element={<Basketball />} />
                <Route
                  path="reservation-confirmation/:id"
                  element={<ReservationConfirmation />}
                />

                <Route path="pickle-ball" element={<PickleBallReservation />} />
                <Route path="sos" element={<SOS />} />
                <Route path="others" element={<OtherRequestServices />} />
                <Route path="laundry" element={<LaundryUser />} />
                <Route path="water" element={<WaterServiceUser />} />
                <Route path="cleaning" element={<CleaningServicesUser />} />
                <Route path="other-services" element={<OtherServicesUser />} />
                <Route path="suppliers" element={<Suppliers />} />

                <Route path="chat" element={<GroupChatHome />} />
                <Route path="group-chats/:id" element={<GroupChat />} />
                <Route path="chats/:id" element={<GroupChat />} />
                <Route path="admin" element={<AdminUser />} />
                <Route path="notifications" element={<NotificationsUser />} />
                <Route
                  path="notif-details/:id"
                  element={<NotificationDetails />}
                />
                <Route path="condo-corp" element={<HoaDirectory />} />
                <Route path="home" element={<UserDashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="userprofile" element={<UserProfile />} />
                <Route path="*" element={<NotPermitted />} />
                <Route
                  path="maintenance-request"
                  element={<MaintenanceRequest />}
                />
                <Route
                  path="maintenance-request-confirmation/:id"
                  element={<MaintenanceRequestConfirmation />}
                />

                <Route path="concerns" element={<ConcernsForm />} />
                <Route
                  path="concern-confirmation/:id"
                  element={<ConcernConfirmation />}
                />
                <Route path="complaints" element={<Complaints />} />
                <Route path="concern/:id" element={<ConcernDetails />} />
                <Route
                  path="/user/concerns"
                  element={<ConcernConfirmationPage />}
                />
                <Route path="register-guests" element={<GuestRegistration />} />
                <Route path="add-guest" element={<AddGuests />} />
                <Route path="edit-guest-card/:id" element={<AddGuests />} />
                <Route path="guest-history" element={<GuestHistory />} />
                <Route path="password" element={<PasswordSecurityUserPage />} />
                <Route path="editprofile" element={<EditProfile />} />

                <Route
                  path="guest-card-details/:id"
                  element={<GuestCardDetails />}
                />
                <Route path="facilities" element={<Facilities />} />
                <Route path="facilities/:id" element={<FacilityDetailPage />} />
              </Route>
            </Routes>
          </Router>
        </div>
      </div>
    );
  }

  if (
    currentUser?.roles?.includes("security") ||
    currentUser?.roles?.includes("security-guard") ||
    currentUser?.roles?.includes("housekeeping") ||
    currentUser?.roles?.includes("mst") ||
    currentUser?.roles?.includes("reception") ||
    currentUser?.roles?.includes("contracted-services") ||
    currentUser?.roles?.includes("maintenance") ||
    currentUser?.roles?.includes("outsourced-contractor")
  ) {
    return (
      <AppWrapper>
        <div className="App">
          <div className="">
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<SecurityDashboard />}>
                  <Route index element={<Home />} />
                  <Route path="dashboard" element={<Home />} />
                  <Route path="announcements" element={<AllAnnouncements />} />
                  <Route path="alerts" element={<Alerts />} />
                  <Route path="incidents" element={<SecurityIncidents />} />
                  <Route
                    path="service-requests"
                    element={<ServiceRequestsMobile />}
                  />
                  <Route path="clock-in-out" element={<ClockInOut />} />
                  <Route path="reporting" element={<SecurityReporting />} />
                  <Route path="admin/mobile/sos" element={<SOS />} />
                  <Route
                    path="admin/mobile/add-work-permit"
                    element={<WorkPermitUser />}
                  />

                  <Route
                    path="work-permit-confirmation/:id"
                    element={<WorkPermitConfirmation />}
                  />
                  <Route path="admin/settings" element={<UserSettings />} />
                  <Route
                    path="/property-management"
                    element={<PropertyManagementSecurity />}
                  />
                  <Route
                    path="admin/notifications"
                    element={<NotificationsSecurity />}
                  />
                  <Route
                    path="notif-details/:id"
                    element={<NotificationDetails />}
                  />
                  <Route
                    path="work-permits"
                    element={<WorkPermitsAdminMobile />}
                  />
                  <Route
                    path="contractor-work-permits"
                    element={<ContractorWorkPermit />}
                  />
                  <Route
                    path="admin/mobile/suppliers"
                    element={<Suppliers />}
                  />
                  <Route
                    path="admin/mobile/residents"
                    element={<AdminResidentListMobile />}
                  />
                  <Route
                    path="admin/mobile/condo-corp"
                    element={<HoaDirectory />}
                  />
                  <Route
                    path="admin/mobile/add-concern"
                    element={<AddConcernMobileAdmin />}
                  />
                  <Route
                    path="admin/mobile/concern/:id"
                    element={<AdminMobileConcernDetails />}
                  />
                  <Route path="parcels" element={<Parcels />} />
                  <Route
                    path="water-meter-reading"
                    element={<WaterMeterReadingTableView />}
                  />
                  <Route path="concerns" element={<AdminMobileConcerns />} />
                  <Route path="parcel-logs" element={<ParcelLogs />} />
                  <Route path="water-logs" element={<WaterLogs />} />
                  <Route path="qr" element={<ScanQR />} />
                  <Route path="chat" element={<GroupChatHome />} />
                  <Route path="group-chats/:id" element={<GroupChat />} />
                  <Route path="chats/:id" element={<GroupChat />} />
                  <Route path="profile" element={<SecurityProfile />} />
                  <Route path="gate-pass" element={<GatepassMobile />} />
                  <Route
                    path="contractor-gate-pass"
                    element={<ContractorGatePassPage />}
                  />
                  <Route
                    path="gate-pass/:id"
                    element={<SecurityGatePassDetails />}
                  />
                  <Route path="gate-pass/add" element={<Gatepass />} />
                  <Route path="inventory" element={<InventoryMobile />} />
                  <Route
                    path="gatepass-confirmation/:id"
                    element={<GatepassConfirmation />}
                  />

                  <Route
                    path="gatepass-mobile/:id"
                    element={<Gatepassdetails />}
                  />
                  <Route
                    path="guest-card-details/:id"
                    element={<GuestCardDetails />}
                  />
                  <Route path="*" element={<UnderConstruction />} />
                  <Route path="guests" element={<Guests />} />

                  <Route path="guests/new" element={<GuestForm />} />
                  <Route
                    path="guest-details/:id"
                    element={<GuestCardDetails />}
                  />
                </Route>
                <Route path="*" element={<UnderConstruction />} />
              </Routes>
            </Router>
          </div>
        </div>
      </AppWrapper>
    );
  }

  // if (
  //   currentUser?.roles?.includes("contracted-services") ||
  //   currentUser?.roles?.includes("outsourced-contractor")
  // ) {
  //   return (
  //     <AppWrapper>
  //       <div className="App">
  //         <div className="">
  //           <Router>
  //             <Routes>
  //               <Route path="/login" element={<Login />} />
  //               <Route path="/" element={<ContractorDashboardLayout />}>
  //                 <Route index element={<ContractorDashboard />} />
  //                 <Route path="/profile" element={<SecurityProfile />} />
  //                 <Route path="/move-in-out" element={<AddMoveIn />} />
  //                 <Route path="/work-permit" element={<AddWorkPermit />} />
  //                 <Route path="/gate-pass" element={<AddGatePass />} />
  //                 <Route path="/tickets" element={<ContractorTickets />} />
  //                 <Route path="/chat" element={<ContractorChat />} />
  //                 <Route path="*" element={<UnderConstruction />} />
  //               </Route>
  //             </Routes>
  //           </Router>
  //         </div>
  //       </div>
  //     </AppWrapper>
  //   );
  // }

  return (
    <AppWrapper>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<Dashboard />}>
              <Route index element={<AdminDashboard />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="admin/mobile" element={<AdminDashboardLayout />}>
                <Route index element={<AdminHomeMobile />} />
                <Route path="home" element={<AdminHomeMobile />} />
                <Route path="overview" element={<AdminMobileOverview />} />
                <Route path="concerns" element={<AdminMobileConcerns />} />
                <Route
                  path="concern/:id"
                  element={<AdminMobileConcernDetails />}
                />
                <Route path="add-concern" element={<AddConcernMobileAdmin />} />
                <Route path="tickets" element={<AdminTicketsPage />} />
                <Route path="chat" element={<AdminChatPage />} />
                <Route path="profile" element={<AdminProfilePage />} />
                <Route path="*" element={<AdminProfilePage />} />
              </Route>
              <Route path="devtool/ai" element={<AiDevTool />} />
              <Route path="tickets" element={<Tickets />} />
              <Route path="marketplace" element={<MarketplaceAdmin />} />
              <Route path="work-week-schedule" element={<WorkWeekSchedule />} />
              <Route
                path="guest-card-details/:id"
                element={<GuestCardDetails />}
              />
              <Route path="overview" element={<AdminDashboard />} />
              <Route
                path="resident-management"
                element={<TenantManagement />}
              />
              <Route
                path="resident/:id"
                element={<ResidentDetailsFullpage />}
              />
              <Route path="tenant/:id" element={<TenantDetailsFullpage />} />
              <Route
                path="property-management"
                element={<PropertyManagement />}
              />
              <Route path="security" element={<SecurityNewPage />} />
              <Route path="inventory" element={<Inventoryv2 />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="facilities" element={<Facilities />} />
              <Route path="facilities/:id" element={<FacilityDetailPage />} />
              <Route path="todos" element={<Todos />} />
              <Route path="announcements" element={<Announcements />} />
              <Route path="finance" element={<Finance />} />
              <Route path="services" element={<Services />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="contacts/org-chart" element={<OrgChart />} />
              <Route path="profile" element={<ProfileWeb />} />
              <Route path="/notifications" element={<NotificationWeb />} />
              <Route path="settings" element={<Settings />} />
              <Route path="*" element={<UnderConstruction />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="work-permits/:id" element={<WorkPermitDetails />} />
          </Routes>
        </Router>
      </div>
    </AppWrapper>
  );
}

export default App;
